import { Params } from '@angular/router';

export function toParams<T>(
	...fns: ((args: Partial<T>) => Params)[]
): (arg: Partial<T>) => Params {
	return (arg: Partial<T>) =>
		fns.reduce(
			(prev: Params, fn: (arg: Partial<T>) => Params) =>
				fn(arg)
					? {
							...prev,
							...fn(arg),
					  }
					: prev,
			{}
		);
}
